import sample from "lodash/sample";
import { metrika } from "../classes/metrika/metrika";

const facts = [
  `коллекция PS Plus — это подборка отличных игр, которые бесплатно получают все
  обладатели PlayStation 5 с активной подпиской PS Plus? God of War, Bloodborne, Fallout
   4, Mortal Kombat X, Resident Evil 7 и многие другие.
   <br/>
   <a href="${metrika.randomizeLink(
     "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhizl&pr=%random%"
   )}">
   Полный список бесплатных игр
   </a>`,

  `PS5 поддерживает технологию Tempest 3D AudioTech, которая нужна для
  высокоточного позиционирования звука и облегчает погружение в мир игры? Чтобы
  испытать новый звук, вам потребуются любые совместимые с PS5 наушники.
  Но лучше
  <a href="${metrika.randomizeLink(
    "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhxeo&pr=%random%"
  )}">
  беспроводная гарнитура PULSE 3D
  </a> — она разработана специально для PS5.`,

  `в 2021 году ожидается выход новых эксклюзивов PlayStation? Среди них два сиквела
  популярных игровых серий — God of War Ragnarok и «Horizon: Запретный запад».`,

  `в игре Astro’s Playroom задействованы все возможности нового контроллера
  DualSence? Тактильная отдача, адаптивные триггеры, датчики перемещения. Иногда
  приходится даже дуть в контроллер, чтобы взаимодействовать с миром игры.
  <br/>
  <a href="${metrika.randomizeLink(
    "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhxeq&pr=%random%"
  )}">
  Узнать больше о DualSence
  </a>`,

  `игра Astro’s Playroom бесплатна и заранее предустановлена на PS5? Бесплатные
  игры в мире PlayStation — не редкость. Например, этой весной PlayStation
  <a href="${metrika.randomizeLink(
    "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhxes&pr=%random%"
  )}">
  раздаст 10 инди-игр и Horizon Zero Dawn
  </a> в рамках инициативы Play At Home, не говоря уже о <a href="${metrika.randomizeLink(
    "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhxew&pr=%random%"
  )}">коллекции PS Plus</a> и ежемесячных играх
  по подписке.`,

  `на PlayStation 5 доступно более 4000 игр с PlayStation 4? Для их запуска нет никаких
  дополнительных условий. Вставьте диск и играйте. Если вы приобрели игру в онлайн-магазине PlayStation Store, нужно просто ее загрузить.`,

  `PlayStation 5 представлена в двух моделях: <a href="${metrika.randomizeLink(
    "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhxfm&pr=%random%"
  )}">с приводом</a> и
  <a href="${metrika.randomizeLink(
    "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhxfp&pr=%random%"
  )}">без
  привода</a>? Ultra HD Blu-Ray-привод позволяет воспроизводить игры и
  фильмы с дисков. В Digital Edition игры устанавливаются через через онлайн-магазин PS Store. По
  производительности обе модели абсолютно одинаковые.`,

  `на PlayStation 5 вышли игры, адаптированные специально под возможности новой
  консоли? Среди них: Astro’s Playroom, Demon’s Souls, «MARVEL Человек-Паук: Майлз Моралес», «Сэкбой: Большое приключение», Destruction All Stars и другие.`
];

export default function getRandomFact() {
  return sample(facts);
}
